import React from 'react';
import { Filters } from '@sm-dashboard/grid-data';
import { useAdminBusinessAdsFilters } from './businessAdsFilters';
import { Box } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import { Button } from '@sm-dashboard/ui-components';

const AdminSearchAndFilters = () => {
  const filters = useAdminBusinessAdsFilters();

  const handleOpenLink = (path: string) => {
    const url = `${window.location.origin}${path}`;
    window.open(url, '_blank');
  };

  return (
    <Filters
      filters={filters}
      filtersAttachedButton={
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 1,
            width: { xs: '100%', md: '400px' }
          }}
        >
          <Button
            onClick={() => handleOpenLink('/business-ads/submit/publisher')}
            startIcon={<OpenInNew />}
            fullWidth={false}
          >
            פרסם מודעה משלך
          </Button>
          <Button
            variant="outlined"
            onClick={() => handleOpenLink('/tools/business-ads/submit/shaliach')}
            startIcon={<OpenInNew />}
            fullWidth={false}
          >
            פרסם מודעה משלך (שליח)
          </Button>
        </Box>
      }
    />
  );
};

export default AdminSearchAndFilters;
